import { render, staticRenderFns } from "./HomeSoftware.vue?vue&type=template&id=dcbdf354&scoped=true&"
import script from "./HomeSoftware.vue?vue&type=script&lang=js&"
export * from "./HomeSoftware.vue?vue&type=script&lang=js&"
import style0 from "./HomeSoftware.vue?vue&type=style&index=0&id=dcbdf354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbdf354",
  null
  
)

export default component.exports